// Helpers puros para el input de custom fields.
// Se extraen de CustomfieldsInputComponent para poder testearlos sin DOM ni Angular.

/**
 * True si el patron restringe a solo digitos con un tope de longitud:
 * ^[0-9]{1,N}$ o ^[0-9]{N}$. Cubre RUC PE, DNI, y cualquier campo numerico
 * con longitud acotada por la regex.
 */
export function isDigitsOnlyPattern(pattern: any): boolean {
  const p = String(pattern || '');
  return /^\^\[0-9\]\{1,\d+\}\$$/.test(p) || /^\^\[0-9\]\{\d+\}\$$/.test(p);
}

/** True si el patron es el del celular PE (prefijo fijo 9 + 8 digitos). */
export function isMobilePePattern(pattern: any): boolean {
  return String(pattern || '') === '^9[0-9]{8}$';
}

/**
 * Extrae el maximo de digitos de un patron de solo-digitos acotado
 * (^[0-9]{1,N}$ o ^[0-9]{N}$). Devuelve null si el patron no calza.
 * Regex ancladas al inicio y fin para no matchear de forma parcial.
 */
export function digitsMaxLengthFromPattern(pattern: any): number | null {
  const p = String(pattern || '');
  const range = /^\^\[0-9\]\{1,(\d+)\}\$$/.exec(p);
  if (range) return Number(range[1]);
  const exact = /^\^\[0-9\]\{(\d+)\}\$$/.exec(p);
  if (exact) return Number(exact[1]);
  return null;
}

/**
 * Normaliza un valor de celular PE (patron ^9[0-9]{8}$):
 * - deja solo digitos,
 * - "" si no hay digitos (no fabrica un "9" espurio que quedaria invalido / no vaciable),
 * - si ya empieza con "9" (numero local): recorta a los PRIMEROS `max`, asi una tecla de
 *   mas sobre un numero ya completo se ignora en vez de correr el numero,
 * - si NO empieza con "9" y hay >= `max` digitos (p.ej. pegado internacional
 *   "+51987654321" -> "51987654321"): toma los ULTIMOS `max` (numero local real 987654321),
 * - si NO empieza con "9" y faltan digitos: antepone el prefijo obligatorio "9".
 */
export function normalizeMobilePePrefix(raw: any, maxlength?: number | null): string {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (digits === '') {
    return '';
  }
  const max = maxlength || 9;
  if (digits.startsWith('9')) {
    // Numero local ya con prefijo: recortar por la derecha (ignora tecleo extra),
    // no por la izquierda (que borraria el "9" y correria el numero).
    return digits.slice(0, max);
  }
  if (digits.length >= max) {
    // Prefijo de pais u otro delante (no empieza con 9): el numero local son los ultimos N,
    // pero solo si asi queda un celular PE valido (empieza con 9). Si no, caemos al prefijo.
    const tail = digits.slice(-max);
    if (tail.startsWith('9')) {
      return tail;
    }
  }
  // Faltan digitos (o el tail no era valido): completar el prefijo obligatorio "9".
  return ('9' + digits).slice(0, max);
}
